<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('coursetemplates.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs4>
              <v-select
                v-model="search_params.status"
                :items="[{ key: 'all', text: $t('global.all') }, ...$dd_course_templates_status()]"
                item-text="text"
                item-value="key"
                :label="$t('coursetemplates.status')"
                @change="filter"
                hide-details
              >
              </v-select>
            </v-flex>
            <v-flex xs4>
              <v-select
                v-model="search_params.type"
                :items="[{ key: 'all', text: $t('global.all') }, ...$dd_course_templates_fixed_type()]"
                item-text="text"
                item-value="key"
                :label="$t('coursetemplates.type')"
                @change="filter"
                hide-details
              >
              </v-select>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link :to="BACKEND_URL + '/coursetemplates/create'" v-if="$can('coursetemplate-create')">
        <action-button type="new" />
      </router-link>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="coursetemplates"
            :items-per-page="coursetemplates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.name="{ item }">
              {{ item.name }}
            </template>

            <template v-slot:item.coursetypegroup_id="{ item }">
              {{ item.coursetypegroup.full_name }}
            </template>

            <template v-slot:item.coursetemplatetype_id="{ item }">
              {{ $dd_course_templates_type(item.coursetemplatetype_id) }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_course_templates_status(item.status) }}
            </template>

            <template v-slot:item.updated_at="{ item }">
              {{ moment.utc(item.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{
                  path: BACKEND_URL + '/coursetemplates/edit/' + item.id,
                  props: { id: item.id }
                }"
                v-if="$can('coursetemplate-edit')"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <action-button type="delete" @click="del(item.id)" v-if="$can('coursetemplate-delete')" :icon_only="true" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypesList",

  data() {
    return {
      url: "",
      coursetemplates: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage('__page_CourseTemplate_List', 'page'),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: [false]
      },
      search_params: {
        any: "",
        name: "",
        status: 1,
        type: "all"
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("coursetemplates.name"), value: "name" },
          {
            text: this.$t("coursetemplates.coursetypegroup_id"),
            value: "coursetypegroup_id"
          },
          {
            text: this.$t("coursetemplates.coursetemplatetype_id"),
            value: "coursetemplatetype_id"
          },
          { text: this.$t("coursetemplates.price"), value: "price" },
          { text: this.$t("coursetemplates.status"), value: "status" },
          { text: this.$t("global.updated"), value: "updated_at" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false
          }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__sort_CourseTemplate_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_CourseTemplate_List", newVal.page)
          }
          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "coursetemplates"
  },

  methods: {
    list() {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_CourseTemplate_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter

        if (!this.search_params.type) {
          this.search_params.type = "all"
        }
      }

      let localSort = localStorage.getItem("__sort_CourseTemplate_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.coursetemplates = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
      localStorage.setItem("__filter_CourseTemplate_List", JSON.stringify(this.search_params))
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetemplate/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
